/**
 * No-op analytics helper kept for compatibility with existing callers.
 */
export class AnalyticsHelper {
  constructor() {
    this.analytics = null;
  }

  async init() {
    this.analytics = null;
  }

  identify() {
    this.analytics = null;
  }

  track() {
    this.analytics = null;
  }

  page() {
    this.analytics = null;
  }
}

export default new AnalyticsHelper();
